import React from "react";

function OptionalValue({ children }) {
  return (
    <>
      <span>{children || "-"}</span>
    </>
  );
}

export default OptionalValue;
